import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxSwitchModule, DxTagBoxModule } from 'devextreme-angular';
import { DxAccordionModule } from 'devextreme-angular';
import { DxButtonModule } from 'devextreme-angular';
import { DxButtonGroupModule } from 'devextreme-angular';
import { DxChartModule } from 'devextreme-angular';
import { DxCheckBoxModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular';
import { DxDateBoxModule } from 'devextreme-angular';
import { DxDropDownBoxModule } from 'devextreme-angular';
import { DxDropDownButtonModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular';
import { DxHtmlEditorModule } from 'devextreme-angular';
import { DxListModule } from 'devextreme-angular';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { DxLookupModule } from 'devextreme-angular';
import { DxNumberBoxModule } from 'devextreme-angular';
import { DxPopoverModule } from 'devextreme-angular';
import { DxPopupModule } from 'devextreme-angular';
import { DxRadioGroupModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxSpeedDialActionModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { DxTextBoxModule } from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular';
import { DxTooltipModule } from 'devextreme-angular';
import { DxTreeListModule } from 'devextreme-angular';
import { DxValidatorModule } from 'devextreme-angular';
import { AddressComponent } from './components/address/address.component';
import { BillToTypeComponent } from './components/bill-to-type/bill-to-type.component';
import { BillToComponent } from './components/bill-to/bill-to.component';
import { BillingInformationComponent } from './components/billing-information/billing-information.component';
import { EditBillingInformationComponent } from './components/billing-information/edit-billing-information/edit-billing-information.component';

import { ClearAllBtnComponent } from './components/clear-all-btn/clear-all-btn.component';
import { ClientPhysicianSelectorDialogComponent } from './components/client-selector/client-physician-selector-dialog/client-physician-selector-dialog.component';
import { ClientSelectorComponent } from './components/client-selector/client-selector.component';
import { CommentsControlComponent } from './components/comments-control/comments-control.component';
import { EmailFaxDialogComponent } from './components/email-fax-dialog/email-fax-dialog.component';
import { FormRelationGlassComponent } from './components/form-relation-glass/form-relation-glass.component';
import { FormRelationSelectorComponent } from './components/form-relation-selector/form-relation-selector.component';
import { FormRelationComponent } from './components/form-relation/form-relation.component';
import { FromToDateRangeSelectorComponent } from './components/from-to-date-range-selector/from-to-date-range-selector.component';
import { GlassWithOptionsComponent } from './components/glass-with-options/glass-with-options.component';
import { GlassComponent } from './components/glass/glass.component';
import { LoadingHeaderComponent } from './components/loading-header/loading-header.component';
import { PatientInfoPopupComponent } from './components/patient-info-popup/patient-info-popup.component';
import { PatientPhysicianHeaderComponent } from './components/patient-physician-header/patient-physician-header.component';
import { PatientResponsiblePartiesComponent } from './components/patient-responsible-parties/patient-responsible-parties.component';
import {
    PatientResponsiblePartyFormDialogComponent
} from './components/patient-responsible-parties/patient-responsible-party-form-dialog/patient-responsible-party-form-dialog.component';
import { PatientResultDialogComponent } from './components/patient-selector/patient-result-dialog/patient-result-dialog.component';
import { PatientSelectorDialogComponent } from './components/patient-selector/patient-selector-dialog/patient-selector-dialog.component';
import { PatientSelectorComponent } from './components/patient-selector/patient-selector.component';
import { PhysicianSelectorDialogComponent } from './components/physician-selector/physician-selector-dialog/physician-selector-dialog.component';
import { PhysicianSelectorComponent } from './components/physician-selector/physician-selector.component';
import { PrintLogBtnComponent } from './components/print-log-btn/print-log-btn.component';
import { PrinterDialogMultipleComponent } from './components/printer-dialog-multiple/printer-dialog-multiple.component';
import { PrinterDialogComponent } from './components/printer-dialog/printer-dialog.component';
import { SearchBtnComponent } from './components/search-btn/search-btn.component';
import { SelectorComponent } from './components/selector/selector.component';
import { SignatureViewerComponent } from './components/signature-viewer/signature-viewer.component';
import { SingleCardModule } from './components/single-card/single-card.component';
import { StatusComponent } from './components/status/status.component';
import { UnitSelectorComponent } from './components/unit-selector/unit-selector.component';
import { UpdateBillToComponent } from './components/update-bill-to/update-bill-to.component';
import { AddressService, ClientService, DiagnosisService, MedicationService, PatientService } from './services';
import { BillingService } from './services/billing.service';
import { OrdersService } from './services/orders.service';
import { RecentPatientService } from './services/recent-patient.service';
import { RecentRequisitionService } from './services/recent-requisition.service';
import { ReportsService } from './services/reports.service';
import { RequisitionService } from './services/requisition.service';
import { SettingsService } from './services/settings.service';
import { MultipleClientSelectorComponent } from './components/multiple-client-selector/multiple-client-selector.component';
import { CommentsDialogComponent } from './components/comments-dialog/comments-dialog.component';

@NgModule({
    exports: [
        SelectorComponent,
        AddressComponent,
        GlassComponent,
        PrintLogBtnComponent,
        StatusComponent,
        BillToTypeComponent,
        UpdateBillToComponent,
        BillToComponent,
        BillingInformationComponent,
        PrinterDialogComponent,
        PrinterDialogMultipleComponent,
        PhysicianSelectorComponent,
        PatientResponsiblePartiesComponent,
        GlassWithOptionsComponent,
        ClientSelectorComponent,
        CommentsControlComponent,
        LoadingHeaderComponent,
        EmailFaxDialogComponent,
        PatientInfoPopupComponent,
        PatientSelectorComponent,
        FromToDateRangeSelectorComponent,
        ClearAllBtnComponent,
        SearchBtnComponent,
        UnitSelectorComponent,
        PatientPhysicianHeaderComponent,
        SignatureViewerComponent,
        FormRelationGlassComponent,
        MultipleClientSelectorComponent,
        CommentsDialogComponent,
    ],
    declarations: [
        SignatureViewerComponent,
        PatientResultDialogComponent,
        PatientPhysicianHeaderComponent,
        EditBillingInformationComponent,
        BillingInformationComponent,
        BillToComponent,
        BillToTypeComponent,
        UpdateBillToComponent,
        PrinterDialogComponent,
        PrinterDialogMultipleComponent,
        AddressComponent,
        StatusComponent,
        SelectorComponent,
        PatientResponsiblePartiesComponent,
        PatientResponsiblePartyFormDialogComponent,
        PrintLogBtnComponent,
        FormRelationComponent,
        CommentsControlComponent,
        GlassComponent,
        GlassWithOptionsComponent,
        LoadingHeaderComponent,
        SelectorComponent,
        EmailFaxDialogComponent,
        ClearAllBtnComponent,
        PatientInfoPopupComponent,
        SearchBtnComponent,
        ClientPhysicianSelectorDialogComponent,
        ClientSelectorComponent,
        PhysicianSelectorComponent,
        PhysicianSelectorDialogComponent,
        UnitSelectorComponent,
        FromToDateRangeSelectorComponent,
        PatientSelectorComponent,
        PatientSelectorDialogComponent,
        FormRelationSelectorComponent,
        FormRelationGlassComponent,
        MultipleClientSelectorComponent,
        CommentsDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxValidatorModule,
        DxTreeListModule,
        DxPopupModule,
        DxDateBoxModule,
        DxHtmlEditorModule,
        DxButtonModule,
        DxTextAreaModule,
        DxAccordionModule,
        DxLookupModule,
        DxNumberBoxModule,
        DxChartModule,
        DxCheckBoxModule,
        DxTabPanelModule,
        DxFormModule,
        DxScrollViewModule,
        DxPopoverModule,
        DxListModule,
        DxTooltipModule,
        DxToolbarModule,
        DxLoadPanelModule,
        DxButtonGroupModule,
        DxLookupModule,
        DxSpeedDialActionModule,
        DxRadioGroupModule,
        DxDropDownButtonModule,
        DxDropDownBoxModule,
        DxLoadIndicatorModule,
        DxDataGridModule,
        DxTagBoxModule,
        DxSwitchModule,
        SingleCardModule
    ],
    providers: [
        DiagnosisService,
        MedicationService,
        AddressService,
        ClientService,
        PatientService,
        BillingService,
        ReportsService,
        RequisitionService,
        RecentPatientService,
        RecentRequisitionService,
        SettingsService,
        OrdersService
    ]
})
export class SharedModule {
}
